import {
  SET_SANKEY_OPTIONS_NAMES,
  SET_SANKEY_OPTIONS_COSTS,
  SET_SANKEY_OPTIONS_VALUES
} from '../constants/actionTypes';

export const setSankeyOptionsCosts = payload => {
  return {
    type: SET_SANKEY_OPTIONS_COSTS,
    payload
  };
};

export const setSankeyOptionsValues = payload => {
  return {
    type: SET_SANKEY_OPTIONS_VALUES,
    payload
  };
};

export const setSankeyOptionsNames = payload => {
  return {
    type: SET_SANKEY_OPTIONS_NAMES,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/sankeyOptions.js